<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        list: [],
        bank: [
          {
            text: 'BRI',
            value: 'BRI',
            icon: require('@/assets/bank/bri.png')
          },
          {
            text: 'BNI',
            value: 'BNI',
            icon: require('@/assets/bank/bni.png')
          },
          {
            text: 'Mandiri',
            value: 'Mandiri',
            icon: require('@/assets/bank/mandiri.png')
          },
          {
            text: 'BCA',
            value: 'BCA',
            icon: require('@/assets/bank/bca.png')
          },
          {
            text: 'CIMB',
            value: 'CIMB',
            icon: require('@/assets/bank/cimb.png')
          },
          {
            text: 'BTN',
            value: 'BTN',
            icon: require('@/assets/bank/btn.png')
          },
          {
            text: 'Genius',
            value: 'Genius',
            icon: require('@/assets/bank/genius.png')
          },
          {
            text: 'Danamon',
            value: 'Danamon',
            icon: require('@/assets/bank/danamon.png')
          },
          {
            text: 'Bukopin',
            value: 'Bukopin',
            icon: require('@/assets/bank/bukopin.png')
          },
          {
            text: 'Permata',
            value: 'Permata',
            icon: require('@/assets/bank/permata.png')
          }
        ]
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        let params = {
          limit: 100000
        }

        this.list = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },
      config () {
        return {
          // CONFIG PARSING API
          api: 'admin/user',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Kode',
              width: '200px',
              value: 'code',
              freeze: false,
              hide: false
            },
            {
              text: 'Unit',
              width: '400px',
              value: 'unit_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Lengkap',
              width: '400px',
              value: 'name',
              freeze: false,
              hide: false
            },
            {
              text: 'Username',
              width: '300px',
              value: 'username',
              freeze: false,
              hide: false
            },
            {
              text: 'Email',
              width: '200px',
              value: 'email',
              freeze: false,
              hide: false
            },
            {
              text: 'Telepon',
              width: '200px',
              value: 'mobilephone',
              freeze: false,
              hide: false
            },
            {
              text: 'Jenis Kelamin',
              width: '200px',
              value: 'gender',
              freeze: false,
              hide: false
            },
            {
              text: 'Alamat',
              width: '400px',
              value: 'address',
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Bank',
              width: '200px',
              value: 'account_bank_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Nomor Rekening',
              width: '200px',
              value: 'account_number',
              freeze: false,
              hide: false
            },
            {
              text: 'Atas Nama Rekening',
              width: '200px',
              value: 'account_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Role',
              width: '200px',
              value: 'role',
              freeze: false,
              hide: false
            },
            {
              text: 'Posisi',
              width: '200px',
              value: 'position',
              freeze: false,
              hide: false
            },
            {
              text: 'Status',
              width: '200px',
              value: 'is_active',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal Bergabung',
              width: '200px',
              value: 'join_date',
              freeze: false,
              hide: false,
              format: 'date'
            },
            {
              text: 'Tanggal Dibuat',
              width: '200px',
              value: 'create_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [
            {
              field: 'unit_id',
              label: 'Unit',
              type: 'select',
              placeholder: 'Contoh. Retail dan Kuliner',
              value: '',
              option: this.list,
              width: '70%',
              required: false
            }
          ],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'name',
              label: 'Nama Lengkap',
              type: 'text',
              placeholder: 'Contoh. John Doe',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'username',
              label: 'Username',
              type: 'text',
              placeholder: 'Contoh. johndoe',
              value: '',
              width: '50%',
              required: true,
              rules: 'required'
            },
            {
              field: 'code',
              label: 'Kode',
              type: 'text',
              placeholder: 'Contoh. 00001',
              value: '',
              width: '40%',
              required: true,
              rules: 'required'
            },
            {
              field: 'email',
              label: 'Email',
              type: 'text',
              placeholder: 'Contoh. johndoe@gmail.com',
              value: '',
              width: '60%',
              required: true,
              rules: 'required|email'
            },
            {
              field: 'mobilephone',
              label: 'Telepon',
              type: 'number',
              placeholder: 'Contoh. 081332XXXXXX',
              value: '',
              width: '50%',
              required: true,
              rules: 'required|required|min:8|max:13'
            },
            {
              field: 'gender',
              label: 'Jenis Kelamin',
              type: 'select',
              placeholder: 'Contoh. Laki-Laki',
              value: '',
              option: [
                {
                  text: 'Laki-Laki',
                  value: 'Laki-Laki'
                },
                {
                  text: 'Perempuan',
                  value: 'Perempuan'
                }
              ],
              width: '50%',
              required: true,
              rules: 'required'
            },
            {
              field: 'address',
              label: 'Alamat',
              type: 'textarea',
              placeholder: 'Contoh. Jl. Pemuda No. 01',
              value: '',
              width: '100%',
              rows: 3,
              required: true,
              rules: 'required'
            },


            {
              field: 'account_bank_name',
              label: 'Nama Bank',
              type: 'select_icon',
              placeholder: 'Contoh. BRI',
              value: '',
              option: this.bank,
              width: '60%',
              required: true,
              rules: 'required'
            },
            {
              field: 'account_number',
              label: 'Nomor Rekening',
              type: 'number',
              placeholder: 'Contoh. XXXXXXXX',
              value: '',
              width: '50%',
              required: true,
              rules: 'required'
            },
            {
              field: 'account_name',
              label: 'Atas Nama Rekening',
              type: 'text',
              placeholder: 'Contoh. John Doe',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },


            {
              field: 'unit_id',
              label: 'Unit',
              type: 'select',
              placeholder: 'Contoh. Sales',
              value: '',
              option: this.list,
              width: '50%',
              required: true,
              rules: 'required'
            },
            {
              label: 'Column',
              type: 'column',
              sub: [
                {
                  field: 'role',
                  label: 'Role',
                  type: 'select',
                  placeholder: 'Contoh. Staff',
                  value: '',
                  option: [
                    {
                      text: 'Staff',
                      value: 'staff'
                    },
                    {
                      text: 'Admin',
                      value: 'admin'
                    }
                  ],
                  required: true,
                  rules: 'required',
                  col: 5
                },
                // {
                //   field: 'position',
                //   label: 'Posisi',
                //   type: 'select',
                //   placeholder: 'Contoh. Marketing',
                //   value: '',
                //   option: [
                //     {
                //       text: 'Marketing',
                //       value: 'marketing'
                //     },
                //     {
                //       text: 'Kolektor',
                //       value: 'kolektor'
                //     },
                //     {
                //       text: 'Administrasi',
                //       value: 'administrasi'
                //     },
                //     {
                //       text: 'Superadmin',
                //       value: 'superadmin'
                //     }
                //   ],
                //   required: true,
                //   rules: 'required',
                //   col: 6
                // }
                {
                  field: 'position',
                  label: 'Posisi',
                  type: 'text',
                  placeholder: 'Contoh. Marketing',
                  value: '',
                  required: true,
                  rules: 'required',
                  col: 6
                }
              ]
            },
            {
              field: 'join_date',
              label: 'Tanggal Bergabung',
              type: 'date',
              placeholder: 'Contoh. 2023-12-12',
              value: '',
              width: '50%',
              picker: false,
              required: true,
              rules: 'required'
            }
          ],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: true,
              api: ''
            },
            add: {
              button: true,
              api: 'admin/user/add',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'admin/user/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'admin/user/delete'
            },
            detail: {
              button: true,
              api: '/officer/'
            },
            active: {
              button: true,
              api: 'admin/user/activate'
            },
            deactive: {
              button: true,
              api: 'admin/user/deactivate'
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: true,
              api: 'admin/user/export'
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>